import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { ViewVariant } from "@/common/ts/layout";
import { CustomerDto } from "@/core/api/generated/v1";

import ContractPaginatedList from "../../../Contract/ListView/ContractPaginatedList";

interface Props {
  customer: CustomerDto;
}

export default function ContractsTabContent({ customer }: Props) {
  return (
    <PageTabContent>
      <ContractPaginatedList
        defaultValues={{
          customerId: customer.id!,
        }}
        displayProps={{
          viewVariant: ViewVariant.Tab,
          header: false,
          filters: true,
        }}
      />
    </PageTabContent>
  );
}
